import { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { NotificationBell } from "@/components/notification-bell";

interface DashboardHeaderProps {
  title: string;
  subtitle: string;
  actionButton?: {
    label: string;
    icon: ReactNode;
    onClick: () => void;
  };
}

/**
 * Reusable Dashboard Header Component
 * Used across Admin, Landlord, and Tenant dashboards
 */
export function DashboardHeader({
  title,
  subtitle,
  actionButton,
}: DashboardHeaderProps) {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">{title}</h1>
        <p className="text-muted-foreground">{subtitle}</p>
      </div>
      <div className="flex items-center gap-2">
        <NotificationBell />
        {actionButton && (
          <Button onClick={actionButton.onClick}>
            {actionButton.icon}
            {actionButton.label}
          </Button>
        )}
      </div>
    </div>
  );
}
